import actions from './constants';

export const fetchRequestAttachments = (category, code, permissions, allowPmnTransfer) => ({
  type: actions.FETCH_REQUEST_ATTACHMENTS,
  category,
  code,
  permissions,
  allowPmnTransfer,
});

export const showRequestAttachments = (category, code, results, permissions, allowPmnTransfer) => ({
  type: actions.SHOW_REQUEST_ATTACHMENTS,
  category,
  code,
  results,
  permissions,
  allowPmnTransfer,
});

export const showRequestAttachmentsError = (category, code, error, permissions, allowPmnTransfer) => ({
  type: actions.SHOW_REQUEST_ATTACHMENTS_ERROR,
  category,
  code,
  error,
  permissions,
  allowPmnTransfer,
});

export const showRequestFolderAttachments = (category, code, results) => ({
  type: actions.SHOW_REQUEST_FOLDER_ATTACHMENTS,
  category,
  code,
  results,
});

export const showRequestFolderAttachmentsError = (category, code, error) => ({
  type: actions.SHOW_REQUEST_FOLDER_ATTACHMENTS_ERROR,
  category,
  code,
  error,
});
